'use client';

import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useMemo,
} from 'react';

import { County as GetCountiesCounty } from '@/endpoints/itasca/county/getCounties';
import { County } from '@/endpoints/itasca/county/getCounty';
import { State } from '@/endpoints/itasca/state/getState';
import { InsightCoverageDataResponse } from '@/models/insightCoverage';

import { CuratedCompSeoExpansion } from './seoExpansion';

type InsightsCoverageProps = PropsWithChildren & {
  insightsCoverage: InsightsCoverage;
};

export type InsightsCoverageContextType = {
  insightsCoverage: InsightsCoverage;
};

export type InsightsCoverage = {
  countyInsightCoverage?: InsightCoverageDataResponse;
  countyInfo?: County;
  stateInfo?: State;
  stateInsightCoverage?: InsightCoverageDataResponse;
  countiesWithListings?: any;
  body?: string;
  stateCounties?: GetCountiesCounty[];
  title?: string;
  countiesWithSoldLand?: CuratedCompSeoExpansion[];
};

const defaultInsightsCoverageContext: InsightsCoverageContextType = {
  insightsCoverage: {},
};

const InsightsCoverageContext = createContext<InsightsCoverageContextType>(
  defaultInsightsCoverageContext
);

export const InsightsCoverageProvider: FC<InsightsCoverageProps> = ({
  children = null,
  insightsCoverage,
}) => {
  const value: InsightsCoverageContextType = useMemo(
    () => ({
      insightsCoverage,
    }),
    [insightsCoverage]
  );

  return (
    <InsightsCoverageContext.Provider value={value}>
      {children}
    </InsightsCoverageContext.Provider>
  );
};

export const useInsightsCoverageContext = () =>
  useContext(InsightsCoverageContext);
